const Post14Summary = (lang) => {
	const isRom = lang === 'rom'

	
	return {
		lang,
		cardTitle: isRom?  'Tânarǎ pentru totdeauna' :'Forever young',	
		cardText:  isRom ?  'Aceasta e continuarea povestii bunicii mele materne, Aurelia, a anilor petrecuti in Bucuresti: sa fi fost secretarǎ de prim ministru si, in general, ce a facut in timpul celui de-al doilea razboi mondial.': 
		'Here is the continuation of the story of my grandmother, Aurelia, her years in Bucharest, could she really have been the secretary of a Romanian prime minister in late 1930s and what sort of war did she have', 
		photoPath: '/post14/collage14l.jpg', 
		photoPathShort: '/post14/collage14s.jpg', 
		linkId: 'young'
	}

}

export default Post14Summary;
